import { render, staticRenderFns } from "./addmsShuCai.vue?vue&type=template&id=47624cc4&scoped=true"
import script from "./addmsShuCai.vue?vue&type=script&lang=js"
export * from "./addmsShuCai.vue?vue&type=script&lang=js"
import style0 from "./addmsShuCai.vue?vue&type=style&index=0&id=47624cc4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47624cc4",
  null
  
)

export default component.exports